import Reveal from './Reveal';
import { useInView } from 'framer-motion';
import { useRef, useEffect, useState } from 'react';
import { STATS } from '../lib/site';

const NUMBER_STYLE = { fontSize: 'clamp(3rem, 6vw, 5rem)' };
const HEADING_STYLE = { fontSize: 'clamp(2rem, 3.5vw, 3rem)' };
const IN_VIEW_OPTS = { once: true, margin: '-60px' };

function AnimatedNumber({ value }) {
  const ref = useRef(null);
  const isInView = useInView(ref, IN_VIEW_OPTS);
  const [display, setDisplay] = useState('0');

  useEffect(() => {
    if (!isInView) return;
    const timer = setTimeout(() => setDisplay(value), 300);
    return () => clearTimeout(timer);
  }, [isInView, value, setDisplay]);

  return (
    <span ref={ref} className="font-display font-semibold text-white" style={NUMBER_STYLE}>
      {display}
    </span>
  );
}

const StatsGrid = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 divide-x divide-y md:divide-y-0 divide-white/10" data-testid="stats-grid">
    {STATS.map((stat, i) => (
      <Reveal
        key={stat.label}
        delay={i * 0.1}
        className="px-8 py-10 lg:px-12 text-center lg:text-left"
        data-testid={`stat-item-${i}`}
      >
        <AnimatedNumber value={stat.value} />
        <p className="mt-3 font-body text-sm text-[#94A3B8] uppercase tracking-[0.15em] font-medium">
          {stat.label}
        </p>
      </Reveal>
    ))}
  </div>
);

export default function Reach() {
  return (
    <section id="reach" className="bg-[#0A1628] py-28 lg:py-36 relative overflow-hidden" data-testid="reach-section">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#00E5FF]/4 rounded-full blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="mb-20 text-center">
          <span className="font-body text-[11px] font-semibold uppercase tracking-[0.25em] text-[#00E5FF]">
            Global Reach
          </span>
          <span className="line-electric mt-3 mb-6 mx-auto block" />
          <h2 className="font-display font-semibold text-white leading-[1.1]" style={HEADING_STYLE}>
            Scale, precision and global presence.
          </h2>
        </Reveal>

        <StatsGrid />

        <div className="mt-20 flex items-center gap-6">
          <div className="flex-1 h-px bg-white/10" />
          <span className="font-body text-[11px] uppercase tracking-[0.3em] text-[#94A3B8]/90">
            Voyager Energy Partners
          </span>
          <div className="flex-1 h-px bg-white/10" />
        </div>
      </div>
    </section>
  );
}
